<template>
  <div>
    <card>
      <div slot="header" class='toolsBar'>
        <div class="leftTools"> 
          <fg-input type="text" placeholder='' v-model="searchForm.name" />
          <div>
            <l-button type="default" @click="doSearch()">搜尋</l-button>
          </div>
        </div>
        <div>
          <l-button type="info" @click="handlenew()" class='text-right'>新增</l-button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <!-- <el-table-column label="  " width="80px;">
              <div>
                <l-checkbox></l-checkbox>
              </div>
            </el-table-column> -->
            <el-table-column label="銷售頁群組">
              <div class="td-actions" slot-scope="props">
                <router-link :to="{ name: 'sale_pages', params: { id: props.row.id, saleGroup:props.row }}">{{props.row.name}}</router-link>
              </div>
            </el-table-column>
            <el-table-column prop="categoryIda" label="銷售筆數" />
            <el-table-column prop="categoryIdaa" label="銷售金額" />                      
            <el-table-column prop="categoryId" :formatter="getCategoryText" label="分類" />
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs" @click="handleEdit(props.row)">
                  <i class="fa fa-edit" />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category" />
        </div>
        <l-pagination class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      @input='handleIndexChange'
                      :total="pagination.total" />
      </div>
    </card>
    <el-dialog
      width="450px"
      center
      :title="getTitle()"
      :visible.sync="modals.custom">
      <fg-input label="銷售頁群組"
                type="text"
                name="name"
                data-vv-as="銷售頁群組"
                v-model="form.name"
                v-validate="'required'"  
                :error="getError('name')"
                required />
      <div class="form-group align-left">
        <label>分類 *</label>
        <el-select class="select-default" data-vv-as="分類" placeholder="請選擇" name="categoryId" v-model="form.categoryId" :error="getError('categoryId')"  v-validate="'required'" >
            <el-option v-for="i in categories" class="select-default" :value="i.id" :label="i.name" :key="i.id" />
        </el-select>
        <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('categoryId')">{{ errors.first('categoryId') }}</div>
      </div>
      <div class="text-right">
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import { Pagination as LPagination } from 'src/components/index'
  import lib from '../../lib'
  import tools from '../../tools'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox,
      LPagination
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        form: {
          id: '',
          name: '',
          categoryId: ''
        },
        searchForm: {
          name: ''
        },
        query: {
          name: '',
        },
        categories:[],
        cuser: null,
        modals: {
          custom: false,
          outOfStock: false,
          history: false
        },
        tableData: []
      }
    },
    async mounted() {
      await this.getCategories()
      await this.getData()
    },
    watch: {
    },
    computed: {

    },
    methods: {
      getCategoryText(row, idx) {
        var id = row.categoryId
        for (var i=0 ; i < this.categories.length ; i++) {
          if (this.categories[i]['id'] == id) {
            return this.categories[i]['name']
          }
        }
        return ''
      },
      doNewRow() {
        this.form.goodsDetails.push({ quantity: 1 })
      },
      getTitle() {
        return (this.form.id == '')?'新增銷售頁群組':'編輯銷售頁群組'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;
          if (this.form.id === '') {
            _this.create()
          } else {
            _this.update()
          }
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      handleEdit(row) {
        this.form.id = row.id
        this.form.name = row.name
        this.form.categoryId = row.categoryId
        this.openModal('custom')
      },
      doSearch() {
        this.pagination.currentPage = 1
        this.query.name = this.searchForm.name
        this.getData()
      },
      async handleIndexChange() {
        await this.getData()
      },
      async getCategories() {
        var data = await lib.categoryList({ offset: 0, limit: 50 })
        if (data.status == 0) {
          var result = data.result
          this.categories = result.categories
        }
      },
      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.getSaleGroupList(this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          this.tableData = result.saleGroups
        }
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.form.id = ''
          _this.form.name = ''
          _this.form.categoryId = ''
          resolve()
        })
      },
      async create() {
        var data = await lib.createSaleGroup(this.form)
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('新增成功', '', 'success')
        } else if (data.status == 7) {
          this.$swal('貨號重複', '', 'error')
        } else if (data.status == 107) {   
          this.$swal('以下料號不存在', data.value.join('<br>'), 'error')
        } else {
          this.$swal('新增失敗', '', 'error')
        }
      },
      async update() {
        var data = await lib.updateSaleGroup(this.form.id, this.form)
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('已更新', '', 'success')
        }
      },
      async handleDelete(id, porp) {
        var result = await tools.confirmDialog(this, "確定要刪除?")
        if (result) {
          var data = await lib.deleteItem(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      },
      async handleUpload(id, porp) {
        var result = await tools.confirmDialog(this, `確定要上傳料號?`)
        if (result) {
          var data = await lib.itemUpload(id)
          if (data.status == 0) {
            this.tableData[porp.$index].status = 1
            this.$notify(
            {
              message:`料號 ${porp.row.number} 已上傳`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "danger"
            })
          } else {
            // this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>


<style>
.toolsBar {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}

.leftTools > * {
  padding-right: 10px;
}
</style>
